/**
 * Entorno: ACCESOS — el ambiente donde se prueba el esquema de accesos nuevo.
 *
 * Usar con:  pnpm run build:accesos   (lo construye el job `build-accesos` del CI
 *                                      cuando se empuja la rama `accesos`)
 *
 * Es el ÚNICO ambiente donde la sesión la emite el servicio de identidad. En
 * dev, qa y prod sigue el SSO anterior, y por eso sus `identidadUrl` van vacíos.
 */
export const environment = {
  production: false,

  /** API del módulo Recursos Humanos en el servidor de desarrollo */
  BaseUrl: 'https://accesos.gateway-rh.srv1954566.hstgr.cloud/api',

  /** Nombre de la cookie/sessionStorage donde vive el JWT */
  tokenName: 'tk-rh',

  /** Portal SSO: destino si el token no existe o expiró */
  logoutUrl: 'https://accesos.srv1954566.hstgr.cloud/',

  /**
   * La API de IDENTIDAD, donde vive la sesión (`/sesion/actual`, `/refrescar`,
   * `/cerrar`). Es un origen DISTINTO al de esta aplicación.
   *
   * ⚠️ En dev, qa y prod va VACÍO y no es un olvido: las cookies
   * `sinay_acceso`/`sinay_refresco` sólo llegan si el `Domain` las cubre, y allí
   * las apps viven en `sinay.com.mx` mientras las APIs se sirven en `sinay.mx`.
   * Son sufijos públicos DISTINTOS, así que ninguna cookie abarca los dos y el
   * corte no puede ser gradual.
   *
   * AQUÍ sí está relleno porque este ambiente vive entero bajo
   * `.srv1954566.hstgr.cloud`: un solo dominio padre, una sola cookie. Es la
   * misma razón por la que `ffacturacion` y `fadminportal` lo tienen puesto sólo
   * en su `environment.accesos.ts`.
   */
  identidadUrl: 'https://accesos.srv1954566.hstgr.cloud/api/v1',

  /** El login central (`flogin`): a donde se manda a quien no tiene sesión. */
  loginUrl: 'https://accesos.srv1954566.hstgr.cloud/',
  /** false en servidor dev: no inyectar datos provisionales */
  isLocalDev: false,
};
